import { useState } from 'react';
import { Check } from 'lucide-react';
import { Field } from '../components/ui/Field';
import { Button } from '../components/ui/Button';

const ALIQUOTAS = [
  { key: 'aliquota_iss',    label: 'ISS' },
  { key: 'aliquota_pis',    label: 'PIS' },
  { key: 'aliquota_cofins', label: 'COFINS' },
  { key: 'aliquota_csll',   label: 'CSLL' },
  { key: 'aliquota_ir',     label: 'IR' },
  { key: 'aliquota_inss',   label: 'INSS' },
];

const fmtPct = (v) => {
  if (v === '' || v === null || v === undefined) return '';
  const n = Number(v);
  if (Number.isNaN(n)) return '';
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const parsePct = (s) => {
  if (s === '' || s === null || s === undefined) return null;
  const n = Number(String(s).replace(/\./g, '').replace(',', '.'));
  return Number.isNaN(n) ? null : n;
};

export function ServicoForm({ initial, onSubmit, onCancel }) {
  const [form, setForm] = useState(() => ({
    codigo:           initial?.codigo           || '',
    descricao:        initial?.descricao        || '',
    aliquota_iss:     fmtPct(initial?.aliquota_iss),
    aliquota_pis:     fmtPct(initial?.aliquota_pis),
    aliquota_cofins:  fmtPct(initial?.aliquota_cofins),
    aliquota_csll:    fmtPct(initial?.aliquota_csll),
    aliquota_ir:      fmtPct(initial?.aliquota_ir),
    aliquota_inss:    fmtPct(initial?.aliquota_inss),
  }));
  const [errors, setErrors] = useState({});

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = () => {
    const e = {};
    if (!form.codigo.trim())    e.codigo = 'Obrigatório';
    if (!form.descricao.trim()) e.descricao = 'Obrigatório';
    setErrors(e);
    if (Object.keys(e).length === 0) {
      onSubmit({
        ...(initial?.id ? { id: initial.id } : {}),
        codigo: form.codigo.trim(),
        descricao: form.descricao.trim(),
        aliquota_iss:    parsePct(form.aliquota_iss),
        aliquota_pis:    parsePct(form.aliquota_pis),
        aliquota_cofins: parsePct(form.aliquota_cofins),
        aliquota_csll:   parsePct(form.aliquota_csll),
        aliquota_ir:     parsePct(form.aliquota_ir),
        aliquota_inss:   parsePct(form.aliquota_inss),
      });
    }
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 14 }}>
        <Field label="Código" required error={errors.codigo}>
          <input className={`input font-mono ${errors.codigo ? 'error' : ''}`}
            value={form.codigo} onChange={e => update('codigo', e.target.value)} />
        </Field>
        <Field label="Descrição do serviço" required error={errors.descricao}>
          <input className={`input ${errors.descricao ? 'error' : ''}`}
            value={form.descricao} onChange={e => update('descricao', e.target.value)} />
        </Field>
      </div>

      <div style={{
        marginTop: 22, fontSize: 11.5, fontWeight: 700, letterSpacing: '.08em',
        textTransform: 'uppercase', color: 'var(--muted)',
        display: 'flex', alignItems: 'center', gap: 10,
      }}>
        <span>Alíquotas dos impostos retidos (%)</span>
        <span style={{ height: 1, background: 'var(--border)', flex: 1 }} />
      </div>
      <div style={{ marginTop: 4, fontSize: 11.5, color: 'var(--muted)', marginBottom: 12 }}>
        Opcional · usadas para calcular tributos aproximados no espelho da NF.
        Deixe em branco se o imposto não se aplica.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
        {ALIQUOTAS.map(a => (
          <Field key={a.key} label={a.label}>
            <div style={{ position: 'relative' }}>
              <input
                className="input font-money"
                inputMode="decimal"
                placeholder="0,00"
                value={form[a.key] || ''}
                onChange={e => update(a.key, e.target.value)}
                style={{ paddingRight: 32 }}
              />
              <span style={{
                position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                color: 'var(--muted)', fontSize: 13.5, fontWeight: 600,
              }}>%</span>
            </div>
          </Field>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 22 }}>
        <Button variant="secondary" onClick={onCancel}>Cancelar</Button>
        <Button onClick={handleSubmit} icon={Check}>Salvar</Button>
      </div>
    </div>
  );
}
